import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, providentFundData, contactProfileData) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(providentFundData, contactProfileData),

            styles: {
                header: {
                    fontSize: 20,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 11,
                font: 'SulaimanLipi'
            },

            info: {
                title: contactProfileData.name + ' - ' + contactProfileData.serial_no + "(PF)"
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (providentFundData, contactProfileData) => {
        return [
            {
                text: contactProfileData.name + ' - ' + contactProfileData.serial_no + "(PF)",
                style: 'header',
                alignment: 'center',
                fontSize: 12,
                decoration: 'underline',
                margin: [0, 0, 0, 10],
                bold: true,
            },
            {

                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    widths: ['30%', '*', '*', '*', '*', '*', '*', '*'],
                    body: [
                        [
                            { text: 'Particulars', rowSpan: 2, style: 'tableHeader', alignment: 'center' },
                            { text: 'Contributions', colSpan: 3, style: 'tableHeader', alignment: 'center' }, {}, {},
                            { text: 'Interest/Profit', colSpan: 3, style: 'tableHeader', alignment: 'center' }, {}, {},
                            { text: 'Grand Total', rowSpan: 2, style: 'tableHeader', alignment: 'center' }
                        ],
                        [
                            '', 'Employee', 'Employer', 'Total', 'Employee', 'Employer', 'Total', ''
                        ],

                        [
                            'Opening Balance',
                            { text: getAmount(providentFundData, 'opening_balance', 'employee_contribution'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'opening_balance', 'employer_contribution'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'opening_balance', 'contribution_total'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'opening_balance', 'employee_interest'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'opening_balance', 'employer_interest'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'opening_balance', 'interest_total'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'opening_balance', 'grand_total'), alignment: 'right' },
                        ],
                        [
                            'Contribution During the Period',
                            { text: getAmount(providentFundData, 'contribution', 'employee'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'contribution', 'employer'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'contribution', 'employee_total'), alignment: 'right' },
                            '', '', '',
                            { text: getAmount(providentFundData, 'contribution', 'employee_total'), alignment: 'right' },
                        ],
                        [
                            'Interest / Profit During the Period',
                            '', '', '',
                            { text: getAmount(providentFundData, 'interest', 'employee'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'interest', 'employer'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'interest', 'employee_total'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'interest', 'employee_total'), alignment: 'right' },
                        ],
                        [
                            'Adjustment During the Period',
                            { text: getAmount(providentFundData, 'adjustment', 'employee_contribution'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'adjustment', 'employer_contribution'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'adjustment', 'contribution_total'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'adjustment', 'employee_interest'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'adjustment', 'employer_interest'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'adjustment', 'interest_total'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'adjustment', 'grand_total'), alignment: 'right' },
                        ],
                        [
                            { text: 'Closing Balance', bold: true },
                            { text: getAmount(providentFundData, 'closing_balance', 'employee_contribution'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'closing_balance', 'employer_contribution'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'closing_balance', 'contribution_total'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'closing_balance', 'employee_interest'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'closing_balance', 'employer_interest'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'closing_balance', 'interest_total'), alignment: 'right' },
                            { text: getAmount(providentFundData, 'closing_balance', 'grand_total'), alignment: 'right' },
                        ],

                    ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0 || rowIndex === 1) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            }
        ];
    };

    const getAmount = (data, section, field) => {
        if (!data) return 0;
        if (!data[section]) return 0;
        if (data[section][field] === undefined || data[section][field] === null) return 0;
        return data[section][field];
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;